'use strict';

import Input from '../utils/Input';
import Brands from '../libs/API/Brands';
import Alert from '../components/Alert';
import BrandCategorySelector from '../components/BrandCategorySelector';

class ModalNewBrand {
  constructor(options) {
    this.main = document.getElementById('modal_new_brand');
    this.autoReset = options && options.autoreset ? true : false;
    this._brandName = (options && options.brandName) || null;
    this._sending = false;
    this._selfQuoteId = null;
    this._submitBtn = this.main.querySelector('.btn_create');
    this._inputName = new Input(
      this.main.querySelector('input[name="brand_name"]')
    );
    this._isOpen = false;
    this._brandCategorySelector = new BrandCategorySelector(this.main.querySelector('.brand-category-selector'));
    this._brandCategorySelector.actionButtonSize = 'medium';
    

    this.main
      .querySelector('.brand-new-cancel')
      .addEventListener('click', e => {
        e.preventDefault();

        this.hide();
      });

    this.main.querySelector('.brand-new-close').addEventListener('click', e => {
      e.preventDefault();

      this.hide();
    });

    this._submitBtn.addEventListener('click', this._onSubmit.bind(this));

    this._brandCategorySelector.addEventListener('brandCategoryChange', () =>
      this._brandCategorySelector.main
        .closest('.form-group')
        .classList.remove('form-group--error')
    );

    document.addEventListener('click', this._onClickDocument.bind(this));
  }

  set name(value) {
    this._inputName.value = value;
  }

  get name() {
    return this._inputName.value;
  }

  set isOpen(value) {
    this._isOpen = value;
  }

  get isOpen() {
    return this._isOpen;
  }

  hide() {
    this.main.classList.remove('modal--anim');

    setTimeout(() => {
      this.main.classList.remove('modal--show');
      document.body.classList.remove('block-scroll');
      this.isOpen = false;
      this._resetForm();
    }, 50);
  }

  show() {
    this.isOpen = true;

    if (this.autoReset) {
      this._resetForm();
    }

    document.body.classList.add('block-scroll');
    this.main.classList.add('modal--show');
    this._inputName.focus();

    setTimeout(() => {
      this.main.classList.add('modal--anim');
    }, 50);
  }

  _onSubmit(e) {
    e.preventDefault();
    
    if (this._sending) {
      return false;
    }

    let name = this._inputName.value.trim();
    let brandCategoryId = this._brandCategorySelector.value;

    let formOk = true;

    if (this._inputName.isEmpty) {
      formOk = false;
      this._inputName.error = true;
    } else if(!this._inputName.isValidNameNoAccents){
      formOk = false;
      this._inputName.errorMessage = '*Invalid name format';
      this._inputName.error = true;
    } else {
      this._inputName.error = false;
    }

    if (!brandCategoryId) {
      formOk = false;
      this._brandCategorySelector.main
        .closest('.form-group')
        .classList.add('form-group--error');
    } else {
      this._brandCategorySelector.main
        .closest('.form-group')
        .classList.remove('form-group--error');
    }

    if (formOk) {
      this._sending = true;
      this._submitBtn.classList.add('link--loading');

      let formData = {
        brands: [
          {
            name: name,
            brand_category_id: brandCategoryId
          }
        ]
      };

      Brands.requestCreate(formData)
        .then(response => {
          Alert.show(
            'success',
            'Your brand request was submitted.',
            "We're currently processing your request and will notify you once your brand has been successfully created."
          );
          this.hide();
          this._submitBtn.classList.remove('link--loading');
          this._sending = false;
        })
        .catch(data => {
          this._sending = false;
          this._submitBtn.classList.remove('link--loading');
          Alert.show(
            'warning',
            'Something went wrong, please try again later.',
            null,
            'Ok'
          );
        });
    }
  }

  _resetForm() {
    this._inputName.value = '';
    this._inputName.input
      .closest('.form-group')
      .classList.remove('form-group--error');

    this._brandCategorySelector.main
      .closest('.form-group')
      .classList.remove('form-group--error');

    this._brandCategorySelector.clear();
  }

  _onClickDocument(e) {
    const isInside = this.main.querySelector('.modal__content').contains(e.target);
    if (!isInside) {
      this.hide();
    }
  }
}

export default ModalNewBrand;
